import React from 'react';
import { Check, Apple, Play } from 'lucide-react';

const PrimeMarketsBanner = ({ 
  phoneImage = "Images/image_2.png"
}) => {
  return (
    <div className="relative bg-black text-white min-h-[400px] overflow-hidden w-full">
      <div className="absolute inset-0 opacity-10">
        <svg viewBox="0 0 1200 600" className="w-full h-full">
          <path
            d="M150,200 Q200,180 250,200 L300,190 Q350,200 400,210 L450,200 Q500,190 550,200 L600,195 Q650,200 700,205 L750,200 Q800,195 850,200 L900,205 Q950,200 1000,195 L1050,200"
            stroke="rgba(255,255,255,0.1)"
            strokeWidth="1"
            fill="none"
          />
          <path
            d="M100,250 Q150,240 200,250 L250,245 Q300,250 350,255 L400,250 Q450,245 500,250 L550,255 Q600,250 650,245 L700,250 Q750,255 800,250 L850,245 Q900,250 950,255 L1000,250"
            stroke="rgba(255,255,255,0.1)"
            strokeWidth="1"
            fill="none"
          />
          <circle cx="200" cy="220" r="2" fill="rgba(255,255,255,0.1)" />
          <circle cx="400" cy="240" r="2" fill="rgba(255,255,255,0.1)" />
          <circle cx="600" cy="230" r="2" fill="rgba(255,255,255,0.1)" />
          <circle cx="800" cy="250" r="2" fill="rgba(255,255,255,0.1)" />
          <circle cx="1000" cy="235" r="2" fill="rgba(255,255,255,0.1)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-[1600px] mx-auto px-8 lg:px-12 py-8 lg:py-12">
        <div className="flex items-center justify-between h-full">
          <div className="flex-1 ">
            <h1 className="text-4xl lg:text-5xl font-bold mb-8 leading-tight text-left">
              Trade on the go with Prime Markets Global mobile app
            </h1>

            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                  <Check size={14} className="text-black" />
                </div>
                <span className="text-lg">Easy monitoring</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                  <Check size={14} className="text-black" />
                </div>
                <span className="text-lg">24/7 Support</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                  <Check size={14} className="text-black" />
                </div>
                <span className="text-lg">Multiple payment methods</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex flex-col justify-between w-full sm:flex-row sm:space-x-4">
                <div>
                <a href="#" className="inline-block mr-2">
                    <img
                    src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                    alt="Get it on Google Play"
                    className="h-12 object-contain"
                    />
                </a>
                <a href="#" className="inline-block">
                    <img
                    src="https://www.sharenet.co.za/v3/images/appBtn2.png"
                    alt="Get it on Google Play"
                    className="h-12 object-contain"
                    />
                </a>
                </div>
            </div>
            </div>
          </div>

          <div className="relative flex-shrink-0 ml-8 hidden lg:block">
            <div className="relative ">
              <div className="w-full h-[580px] bg-black rounded-[2.5rem] p-2 shadow-2xl">
                <div className="w-full h-full bg-white rounded-[2rem] overflow-hidden">
                  <img 
                    src={phoneImage} 
                    alt="IC Markets Global mobile app" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
        
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimeMarketsBanner;